import { render, staticRenderFns } from "./WalletShareProcess.vue?vue&type=template&id=9a137eac"
import script from "./WalletShareProcess.vue?vue&type=script&lang=js"
export * from "./WalletShareProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports